import React, { Component } from "react";
import { withRouter, Route, Switch, Redirect } from "react-router-dom";
import "./dashboard.css";
import "../../styles/detailSections.css";
import DashboardService from "./DashboardService.jsx";
import PaymentInfoModal from "../../components/modals/payment-info-modal/PaymentInfoModal.jsx";
import FBOModal from "../../components/modals/fbo-modal/FBOModal.jsx";
import HomeUnverified from "../home/unverified/HomeUnverified.jsx";
import TerminalShell from "./TerminalShell.jsx";
import Settings from "../settings/settings/Settings.jsx";
import IdVerification from "../settings/id-verification/IdVerification.jsx";
import ChangeEmail from "../settings/changeEmail/ChangeEmail.jsx";
import VerifyEmail from "../settings/verifyEmail/VerifyEmail.jsx";
import ChangePhone from "../settings/changePhone/ChangePhone.jsx";
import VerifyPhone from "../settings/verifyPhone/VerifyPhone.jsx";
import ResultPage from "../result/ResultPage.jsx";
import { utils } from "../../utils/Utils.jsx";
import ErrorBoundary from "../../components/errorBoundary/ErrorBoundary.jsx";
import SideBar from "../../components/side-bar/SideBar.jsx";
import UnverifiedNavBar from "../../components/side-bar/unverified-nav-bar/UnverifiedNavBar.jsx";
import ThemeRegionDiv from "../../components/theme-region-div2/ThemeRegionDiv.jsx";
import {
  setupAuthInterceptor,
  ejectAuthInterceptor,
} from "../../apis/axios-client/authInterceptor.jsx";
import { Spinner } from "react-bootstrap";
import CommandPalette from "../../components/command-palette/CommandPalette.jsx";
import useKeyboardShortcuts from "../../utils/useKeyboardShortcuts.js";

/* Functional wrapper to use hooks inside a class component render tree */
const KeyboardShortcuts = () => { useKeyboardShortcuts(); return null; };

class Dashboard extends Component {
  state = {
    goBackNavBar: false,
    goBackUrl: null,

    showPaymentInfoModal: process.env.REACT_APP_COMPANY_HEADER == "godirectpay",

    collapsedSideBar: null,
    collapsedNavBar: null,

    globalProps: {
      countries: [],
      areaCodes: [],
    },

    isLoading: true,
    DashboardVerifiedRoutes: null, // Will hold lazy loaded component
  };

  service = new DashboardService();

  componentDidMount() {
    console.log("this.props", this.props);
    setupAuthInterceptor(this.props, this.props.setConfig, this.props.setToken);

    if (this.props.token && this.props.config) {
      /*
      this.setState({
        account: JSON.parse(utils.getTokenFromStorage()),
      });*/
      console.log("Token and config found, fetching client config");
      this.loadData();
    } else {
      console.log("no token or account");
      utils.goToURL(this.props, "/");
    }
  }

  componentDidUpdate(prevProps) {
    // Check if config has changed
    if (this.props != prevProps && this.props.config) {
      console.log("Props changed in Dashboard", this.props);
      this.setState(
        {
          config: this.props.config,
        },
        () => {
          if (
            this.props.config?.email_validated &&
            this.props.config?.phone_validated &&
            this.props.config?.kyc_completed
          ) {
            this.importDashboardVerifiedRoutes();
          } else {
            this.setState({ isLoading: false });
          }
        },
      );
    }

    // Reset goBackUrl when pathname changes
    if (
      prevProps.location &&
      this.props.location &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.setState({
        goBackUrl: null,
      });
    }
  }

  componentWillUnmount() {
    ejectAuthInterceptor();
  }

  changeGoBackNavBar = (value, url) => {
    console.log("Navbar back being changed");
    console.log("value", value);
    console.log("url", url);
    this.setState({
      goBackNavBar: value,
      goBackUrl: url,
    });
  };

  loadData = () => {
    if (
      this.props.config?.email_validated &&
      this.props.config?.phone_validated &&
      this.props.config?.kyc_completed
    ) {
      this.importDashboardVerifiedRoutes();
    } else {
      this.setState({ isLoading: false });
    }

    this.service.getCountries(this.state.globalProps, this.setState.bind(this));
    this.service.getAreaCodes(
      this.props.token,
      this.state.globalProps,
      this.setState.bind(this),
    );
  };

  importDashboardVerifiedRoutes = () => {
    console.log("Importing DashboardVerifiedRoutes");
    return import("./verified-routes/DashboardVerifiedRoutes.jsx").then(
      (module) => {
        this.setState({
          DashboardVerifiedRoutes: module.default,
          isLoading: false,
        });
      },
    );
  };

  getPageContainerClass = () => {
    let className = "welcome-div-container";
    if (this.state.collapsedSideBar != null && this.state.collapsedSideBar) {
      className = className + " welcome-div-container-side-bar-collapsed";
    }
    if (this.state.collapsedNavBar != null) {
      className = className + " welcome-div-container-nav-bar ";
    }
    if (
      !this.props.config?.email_validated ||
      !this.props.config?.phone_validated ||
      !this.props.config?.kyc_completed
    ) {
      className = className + " welcome-div-container-user-not-verified";
    }

    return className;
  };

  refreshConfig = () => {
    this.service.getClientConfig(this.props.token, this.props.setConfig);
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div
          className="pulse-animation"
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="loading-config-div fade-in-up">
            <Spinner size="m"></Spinner>
            <div>{this.props.localizedText["loading"]}...</div>
          </div>
        </div>
      );
    }

    const DashboardVerifiedRoutes = this.state.DashboardVerifiedRoutes;
    return (
      <React.Fragment>
        <ErrorBoundary
          localizedText={this.props.localizedText}
          caughtAt={"Dashboard General"}
        >
          <CommandPalette
            config={this.props.config}
            localizedText={this.props.localizedText}
          />
          <KeyboardShortcuts />

          {this.state.collapsedNavBar == null ? (
            <ThemeRegionDiv
              config={this.props.config}
              changeTheme={this.props.changeTheme}
              theme={this.props.theme}
              handleModalOpen={this.props.handleModalOpen}
              region={this.props.region}
              localizedText={this.props.localizedText}
              userVerified={
                this.props.config?.phone_validated &&
                this.props.config?.email_validated &&
                this.props.config?.kyc_completed
              } //remove this eventually, move theme region to side bar and navbar respectively
            ></ThemeRegionDiv>
          ) : null}

          {/* Sidebar hidden — all navigation now through tabs on Home */}
          {!this.props.config?.phone_validated ||
          !this.props.config?.email_validated ||
          !this.props.config?.kyc_completed ? (
            <UnverifiedNavBar theme={this.props.theme} />
          ) : null}

          <Switch>
            <Route
              exact
              path="/dashboard/settings/id-verification"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <IdVerification
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      phone_validated={this.props.config?.phone_validated}
                      email_validated={this.props.config?.email_validated}
                      kyc_completed={this.props.config?.kyc_completed}
                      getClientConfig={this.refreshConfig}
                    ></IdVerification>
                  </ErrorBoundary>
                </div>
              )}
            />
            <Route
              exact
              path="/dashboard/result/:type/:success"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <ResultPage
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      theme={this.props.theme}
                      resultType="inside"
                    ></ResultPage>
                  </ErrorBoundary>
                </div>
              )}
            />
            <Route
              exact
              path="/dashboard/settings"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <Settings
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      theme={this.props.theme}
                      handleInactivity={this.props.handleInactivity}
                      sideBarLayoutFlag={this.state.sideBarLayoutFlag}
                      toggleSideBarLayoutFlag={(value) => {
                        this.setState({
                          sideBarLayoutFlag: value,
                        });
                      }}
                    ></Settings>
                  </ErrorBoundary>
                </div>
              )}
            />
            <Route
              exact
              path="/dashboard/settings/change-email"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <ChangeEmail
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      getClientConfig={this.refreshConfig}
                    ></ChangeEmail>
                  </ErrorBoundary>
                </div>
              )}
            />
            <Route
              exact
              path="/dashboard/settings/verify-email"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <VerifyEmail
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      getClientConfig={this.refreshConfig}
                    ></VerifyEmail>
                  </ErrorBoundary>
                </div>
              )}
            />
            <Route
              exact
              path="/dashboard/settings/change-phone"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <ChangePhone
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      getClientConfig={this.refreshConfig}
                      globalProps={this.state.globalProps}
                    ></ChangePhone>
                  </ErrorBoundary>
                </div>
              )}
            />
            <Route
              exact
              path="/dashboard/settings/verify-phone"
              render={(props) => (
                <div class={this.getPageContainerClass()}>
                  <ErrorBoundary
                    localizedText={this.props.localizedText}
                    caughtAt={"Dashboard Switch"}
                  >
                    <VerifyPhone
                      config={this.props.config}
                      token={this.props.token}
                      changeGoBackNavBar={this.changeGoBackNavBar}
                      region={this.props.region}
                      localizedText={this.props.localizedText}
                      getClientConfig={this.refreshConfig}
                    ></VerifyPhone>
                  </ErrorBoundary>
                </div>
              )}
            />

            {/* Bloomberg-style Terminal shell — still reachable at
                /dashboard/terminal but no longer the default landing.
                Verified users now land on the legacy DashboardVerifiedRoutes
                (Home page) as they did before commit 21ce86a1. */}
            <Route
              path="/dashboard/terminal"
              render={(props) => (
                <ErrorBoundary
                  localizedText={this.props.localizedText}
                  caughtAt={"Terminal Shell"}
                >
                  <TerminalShell
                    config={this.props.config}
                    token={this.props.token}
                    onSignOut={this.props.handleInactivity}
                    onSettings={() => props.history.push("/dashboard/settings")}
                    onCards={() => props.history.push("/dashboard/company-cards")}
                  />
                </ErrorBoundary>
              )}
            />

            {!this.props.config?.email_validated ||
            !this.props.config?.phone_validated ||
            !this.props.config?.kyc_completed ? (
              <Route
                exact
                path="/dashboard"
                render={(props) => (
                  <div class={this.getPageContainerClass()}>
                    <ErrorBoundary
                      localizedText={this.props.localizedText}
                      caughtAt={"Dashboard Switch"}
                    >
                      <HomeUnverified
                        globalProps={this.state.globalProps}
                        config={this.props.config}
                        token={this.props.token}
                        changeGoBackNavBar={this.changeGoBackNavBar}
                        region={this.props.region}
                        theme={this.props.theme}
                        localizedText={this.props.localizedText}
                        phoneValidated={this.props.config?.phone_validated}
                        emailValidated={this.props.config?.email_validated}
                        idValidated={this.props.config?.kyc_completed}
                      />
                    </ErrorBoundary>
                  </div>
                )}
              />
            ) : (
              <DashboardVerifiedRoutes
                globalProps={this.state.globalProps}
                config={this.props.config}
                token={this.props.token}
                goBackUrl={this.state.goBackUrl}
                changeTheme={this.props.changeTheme}
                theme={this.props.theme}
                handleModalOpen={this.props.handleModalOpen}
                region={this.props.region}
                localizedText={this.props.localizedText}
                setConfig={this.props.setConfig}
                setToken={this.props.setToken}
                handleInactivity={this.props.handleInactivity}
                sideBarLayoutFlag={this.state.sideBarLayoutFlag}
                collapsedSideBar={this.state.collapsedSideBar}
                collapsedNavBar={this.state.collapsedNavBar}
                getPageContainerClass={this.getPageContainerClass}
                changeGoBackNavBar={this.changeGoBackNavBar}
                getClientConfig={this.refreshConfig}
                adminRoles={this.props.adminRoles}
                emailValidated={this.props.config?.email_validated}
                phoneValidated={this.props.config?.phone_validated}
                idValidated={this.props.config?.kyc_completed}
              />
            )}

            <Route path="/" render={(props) => <Redirect to="/dashboard" />} />
          </Switch>
          {this.state.showPaymentInfoModal ? (
            <PaymentInfoModal
              localizedText={this.props.localizedText}
            ></PaymentInfoModal>
          ) : null}
          {this.props.config?.domicile === "US" &&
          (this.props.config?.privateAccountStatus === null ||
            this.props.config?.privateAccountStatus === "" ||
            this.props.config?.privateAccountStatus === "none") ? (
            <FBOModal localizedText={this.props.localizedText} />
          ) : null}
        </ErrorBoundary>
      </React.Fragment>
    );
  }
}

export default withRouter(Dashboard);
